import { combineEpics } from 'redux-observable';
import type { State, Action } from '../../state/types.tsx';
import { clearFilterRequestEpic } from './clear-filter-request/index.tsx';
import { filteredCardsRequestEpic } from './filter-request/index.tsx';
import { refilterRequestEpic } from './refilter-request/index.tsx';

export const filteredCardsEpic = combineEpics<Action, State>(
	filteredCardsRequestEpic,
	refilterRequestEpic,
	clearFilterRequestEpic,
);
